// Reference pitch: 105 × 68 m. Markings: IFAB Law 1.
// https://theifab.com/laws/latest/the-field-of-play/
export const PITCH = { length: 105, width: 68, penaltyDepth: 16.5, penaltyWidth: 40.32, goalAreaDepth: 5.5, goalAreaWidth: 18.32, spot: 11, radius: 9.15, goal: 7.32 };

export function pitchViewport(width, height, orientation = 'full') {
  const half = orientation.startsWith('half');
  const vertical = orientation.endsWith('vertical');
  const metresWidth = vertical ? 68 : half ? 52.5 : 105;
  const metresHeight = vertical ? (half ? 52.5 : 105) : 68;
  const scale = Math.min((width - 36) / metresWidth, (height - 36) / metresHeight);
  return { scale, x: (width - metresWidth * scale) / 2, y: (height - metresHeight * scale) / 2, metresWidth, metresHeight };
}

export function drawRegulationPitch(ctx, width, height, orientation = 'full') {
  ctx.fillStyle = '#1a7a3a'; ctx.fillRect(0, 0, width, height);
  const v = pitchViewport(width, height, orientation);
  ctx.save(); ctx.translate(v.x, v.y); ctx.scale(v.scale, v.scale);
  // All geometry uses a common metric scale: circles cannot become ellipses.
  ctx.strokeStyle = 'rgba(255,255,255,.7)'; ctx.lineWidth = 0.12;
  ctx.fillStyle = 'rgba(255,255,255,.7)';
  const vertical = orientation.endsWith('vertical');
  if (vertical) { ctx.translate(68, 0); ctx.rotate(Math.PI / 2); }
  const length = orientation.startsWith('full') ? 105 : 52.5;
  for (let i = 0; i < 10; i++) {
    ctx.fillStyle = i % 2 ? '#178035' : '#1d8240';
    ctx.fillRect(i * length / 10, 0, length / 10, 68);
  }
  ctx.fillStyle = 'rgba(255,255,255,.7)';
  ctx.strokeRect(0, 0, length, 68);
  const line = (x1, y1, x2, y2) => { ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke(); };
  const dot = (x, y) => { ctx.beginPath(); ctx.arc(x, y, .3, 0, 2 * Math.PI); ctx.fill(); };
  const end = () => {
    ctx.strokeRect(0, (68 - 40.32) / 2, 16.5, 40.32);
    ctx.strokeRect(0, (68 - 18.32) / 2, 5.5, 18.32);
    ctx.strokeRect(-1.5, (68 - 7.32) / 2, 1.5, 7.32);
    dot(11, 34);
    const angle = Math.acos((16.5 - 11) / 9.15);
    ctx.beginPath(); ctx.arc(11, 34, 9.15, -angle, angle); ctx.stroke();
    ctx.beginPath(); ctx.arc(0, 0, 1, 0, Math.PI / 2); ctx.stroke();
    ctx.beginPath(); ctx.arc(0, 68, 1, -Math.PI / 2, 0); ctx.stroke();
  };
  end();
  if (orientation.startsWith('full')) {
    ctx.save(); ctx.translate(105, 68); ctx.rotate(Math.PI); end(); ctx.restore();
    line(52.5, 0, 52.5, 68);
    ctx.beginPath(); ctx.arc(52.5, 34, 9.15, 0, Math.PI * 2); ctx.stroke();
  } else {
    ctx.beginPath(); ctx.arc(52.5, 34, 9.15, Math.PI / 2, Math.PI * 1.5); ctx.stroke();
  }
  dot(52.5, 34); ctx.restore();
}

// Old boards used distorted pitches with goals at the top. Reproject positions,
// both arrow ends and polygon vertices once; persisted v2 elements never move again.
export function upgradePitchElements(elements, orientation, legacy = false) {
  const old = legacy ? { width: 700, height: 460 } : ({
    full: { width: 820, height: 520 },
    'half-vertical': { width: 540, height: 620 },
    'half-horizontal': { width: 760, height: 460 },
  }[orientation] || { width: 540, height: 620 });
  const next = legacy ? { width: 700, height: 460 } : ({
    full: { width: 820, height: 544 },
    'half-vertical': { width: 716, height: 561 },
    'half-horizontal': { width: 561, height: 716 },
  }[orientation] || { width: 716, height: 561 });
  const project = p => orientation === 'full'
    ? { x: p.y / old.height * next.width, y: (1 - p.x / old.width) * next.height }
    : { x: p.x / old.width * next.width, y: p.y / old.height * next.height };
  return (elements || []).map(el => el.pitch_version === 2 ? el : {
    ...el, ...project(el), pitch_version: 2,
    ...(el.x2 !== undefined ? { x2: project({ x: el.x2, y: el.y2 }).x, y2: project({ x: el.x2, y: el.y2 }).y } : {}),
    ...(el.points ? { points: el.points.map(project) } : {}),
    ...(orientation === 'full' && el.x2 === undefined && !el.points && el.shape !== 'circle' && !el.tool?.startsWith('player_') && el.shape !== 'text' && el.tool !== 'text' ? { rotation: (el.rotation || 0) - Math.PI / 2 } : {}),
  });
}
